<template>
  <div class="col-12">
    <div>
      <b-card>
        <b-col cols="12">
          <h5>{{ $lang.send_national_code_participant }}</h5>
          <b-form @submit.prevent="getCode()">
            <b-form-group>
              <b-input-group>
                <b-form-input
                  type="text"
                  class="input-style-offres w-75"
                  :autocomplete="$lang.code"
                  v-model="$v.code.$model"
                  :state="$v.code.$dirty ? !$v.code.$error : null"
                >
                </b-form-input>

                <span v-if="code" @click="clear" key="fa-times ">
                  <i class="fa fa-times remove_value" aria-hidden="true"></i>
                </span>

                <b-input-group-prepend>
                  <b-button
                    class="btn-lightgray"
                    @click="getCode"
                    v-b-tooltip.hover
                    :title="$lang.search.search_tooltip"
                  >
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-input-group-prepend>
                <div
                  class="invalid-feedback"
                  v-if="!$v.code.required"
                  id="father_name-feedback"
                >
                  {{ $lang.error_required | replace($lang.code) }}
                </div>
                <div class="invalid-feedback" v-if="!$v.code.numeric">
                  {{ $lang.error_numeric | replace($lang.code) }}
                </div>
                <div
                  class="invalid-feedback"
                  v-if="
                    $v.code.numeric && !$v.code.minLength | !$v.code.maxLength
                  "
                >
                  {{ $lang.error_max | replace($lang.code, 10) }}
                </div>
              </b-input-group>
            </b-form-group>
          </b-form>
        </b-col>
      </b-card>
      <div v-if="isLoading" class="w-100 text-center mt-2">
        <b-spinner variant="primary"></b-spinner>
      </div>

      <b-col
        cols="12"
        v-if="Object.keys(item).length > 0 && !isLoading"
        class="px-0 mt-2"
      >
        <b-overlay :show="isLoading" :opacity="1" rounded="sm">
          <template #overlay>
            <br />
          </template>
          <b-card>
            <div slot="header">پذیرش مصاحبه</div>
            <b-row>
              <b-col cols="12" class="px-0">
                <interviewAudienc :audience="person" :img_kind="img_kind" />
              </b-col>
              <b-col cols="12" md="12" class="mt-2 px-0">
                <searchFilter
                  :pageLoading="isLoading"
                  :items="table_data"
                  :totalRows="table_data.length"
                  :headers="headers_fields"
                  :title="$lang.execute_plan"
                  :permissionButtons="parentPermissions"
                  :perPage="1000"
                >
                  <template slot="loader">
                    <b-spinner variant="primary" v-if="isLoading"></b-spinner>
                  </template>
                </searchFilter>
              </b-col>
              <b-col
                v-if="interviewPersonKind === 2 && person_code"
                cols="12"
                md="12"
                class="mt-2 px-0"
              >
                <uploadFile
                  title="فایل‌ها"
                  :topAlert="$lang.interviewAcceptingUpload"
                  :keyServies="`person`"
                  :keyValue="person_code"
                  :file_types="file_types"
                  attachmentRoute="attachment_person"
                  :parentPermissions="parentPermissions"
                  :allowCollapse="true"
                  :isCollapseFiles="true"
                  :parentUploadFile="true"
                  :dynamicParentBtn="dynamicParentBtn"
                  :maxUploadFile="10485760"
                  :allowFileSize="10240"
                  :acceptFormats="acceptFormats"
                  :outParams="getOutParams('attachment_type_person')"
                />
              </b-col>
              <b-col
                v-if="interviewPersonKind === 2 && interviewId"
                cols="12"
                md="12"
                class="mt-2 px-0"
              >
                <uploadFile
                  title="فایل‌ها"
                  topAlert="لطفا عکس متقاضی در روز مصاحبه اینجا آپلود شود"
                  keyServies="interview_location_person"
                  :keyValue="interviewId"
                  :file_types="file_types"
                  attachmentRoute="attachment_interview_accepting"
                  :parentPermissions="parentPermissions"
                  :propAttachmentType="true"
                  :allowCollapse="true"
                  :isCollapseFiles="true"
                  :parentUploadFile="true"
                  :dynamicParentBtn="dynamicParentBtn"
                  :parent_attachment_type_options="attachment_type_interview"
                  :maxUploadFile="10485760"
                  :allowFileSize="10240"
                  :acceptFormats="acceptFormats"
                  :outParams="getOutParams('attachment_type_interview')"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-overlay>
      </b-col>
    </div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  numeric,
  maxLength,
} from "vuelidate/lib/validators";
import uploadFile from "@/components/base/uploadFile";
import interviewAudienc from "../components/interviewAudienc";
import searchFilter from "@/components/base/searchFilter";
import { renderEumOptions } from "@/shared/utils";
import { includes, pathOr } from "ramda";

export default {
  validations: {
    code: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(10),
      numeric,
    },
  },
  components: {
    uploadFile,
    interviewAudienc,
    searchFilter,
  },
  data() {
    return {
      acceptFormats: [
        {
          caption: "عکس",
          value: "10MB",
        },
        {
          caption: "مجموعه آفیس",
          value: "20MB",
        },
        {
          caption: "ویدیو/صوت",
          value: "50MB",
        },
        {
          caption: "بقیه فایل‌ها",
          value: "10MB",
        },
      ],
      isLoading: false,
      item: {},
      img_kind: null,
      url: null,
      person_code: null,
      view_interview: false,
      hiddenFields: [],
      table_data: [],
      headers_fields: [],
      code: null,
      azmoon_execute_id: null,
      interview_master: null,
      parentPermissions: ["admin"],
      person: {},
      file_types: ["image", "office", "media", "other"],
      interviewId: null,
      interviewPersonKind: null,
    };
  },
  computed: {
    attachment_type_interview() {
      return renderEumOptions("attachment_type_interview").filter(
        (item) => item.value === 21
      );
    },
  },
  methods: {
    renderEumOptions,
    includes,
    pathOr,
    close() {
      this.$router.push("/");
    },
    dynamicParentBtn(x) {
      let buttons = [];
      if (x.confirm_type && x.confirm_type.id == 1) {
        buttons = [
          {
            id: "3",
            name: "edit",
          },
        ];
      } else {
        if (x.type.match("image")) {
          buttons = [
            {
              id: "0",
              name: "delete",
            },
            {
              id: "1",
              name: "edit",
            },
            {
              id: "2",
              name: "crop",
            },
          ];
        } else {
          buttons = [
            {
              id: "1",
              name: "edit",
            },
          ];
        }
      }

      return buttons;
    },
    async getCode() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      this.isLoading = true;
      try {
        const url =
          this.$config.api_url +
          this.$config.interview.interview_accepting.replace("{0}", this.code);

        const response = await this.$httpService.get(url);
        const data = pathOr({}, ["data"], response);

        this.isLoading = true;
        this.item = pathOr({}, ["data"], data);
        this.person = pathOr({}, ["person"], this.item);
        this.person_code = pathOr(null, ["code"], this.person);
        this.img_kind = pathOr(null, ["attachment", "url"], this.person);
        const interview = pathOr([], ["interview"], this.item);
        this.interviewPersonKind = pathOr(
          null,
          ["0", "interview_person_kind", "id"],
          interview
        );
        const currentInterview = interview.find(
          (item) => item.current_interview
        );
        this.interviewId = pathOr(
          null,
          ["interview_location_person_id"],
          currentInterview
        );
        this.getFilterItems(interview);
        this.isLoading = false;
        this.$notify.success(data.message);
      } catch (error) {
        this.$generateError(error);
        this.code = null;
        this.clear();
      } finally {
        this.isLoading = false;
      }
    },
    clear() {
      this.img_kind = null;
      this.person_code = null;
      (this.person = null), (this.code = null);
      this.item = {};
    },
    getFilterItems(data) {
      if (data.length > 0) {
        this.table_data = data.map((x) => {
          return {
            id: x.id,
            interview_date: x.interview_date.jalali,
            interview_time: x.interview_time,
            place_caption: x.place_caption,
            room_name: x.room.room_name,
            room_number: x.room.room_number,
            interview_person_kind: x.interview_person_kind.caption,
          };
        });
        if (this.table_data.length > 0) {
          Object.keys(this.table_data[0]).map((col) => {
            if (
              col in this.$lang.searchInterviewAccepting &&
              col != "reference"
            ) {
              let sorting =
                col == `related_competency` ||
                col == "value" ||
                col == `evidence_count`
                  ? false
                  : true;

              this.headers_fields.push({
                label: this.$lang.searchInterviewAccepting[col],
                key: col,
                sortable: sorting,
                filter: false,
              });
            }
          });
        }
        return true;
      } else {
        this.table_data = [];
        this.headers_fields = [];
      }
    },
    availableButtons(item) {
      return this.buttons.filter((x) =>
        x.is_confirmed.includes(item.is_confirmed)
      );
    },
    cancel() {
      this.view_interview = false;
    },
    AddInterview() {
      this.view_interview = true;
    },
    getOutParams(key) {
      return {
        attachment_type_id: renderEumOptions(key).map((item) => item.value),
      };
    },
  },
};
</script>

<style>
.open-tab {
  animation: open 1s;
}

.detail_body {
  display: block;
}

.text_details {
  cursor: pointer;
  color: red;
}

@keyframes open {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.remove_value {
  position: absolute;
  top: 10px;
  left: 45px;
  color: #ff000094;
  cursor: pointer;
  z-index: 99;
}
</style>
